import React from 'react';

const TermConditions = () => {

    return (
        <div className='bg-gray-100'>
            <div className="max-w-5xl mx-auto px-4 py-10 bg-gray-100">
                <h1 className="text-3xl font-bold mb-6">Terms And Conditions</h1>
                <h2 className=" text-sm text-gray-500 mb-4">Last updated: November 22, 2024</h2>
                <p className="text-sm text-gray-800 mb-4">
                    This Term & Conditions describes Our policies and procedures on the collection, use and disclosure of Your
                    information when You use the Service and tells You about Your privacy rights and how the law protects You.
                </p>
                <p className="text-sm text-gray-800 mb-4">
                    We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection
                    and use of information in accordance with this Term & Conditions.
                </p>

                <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Interpretation and Definitions</h3>
                <h4 className="text-lg font-semibold text-gray-800 mb-1">Interpretation</h4>
                <p className="text-sm text-gray-800 mb-4">
                    The words of which the initial letter is capitalized have meanings defined under the following conditions...
                </p>

                <h4 className="text-lg font-semibold text-gray-800 mb-1">Definitions</h4>
                <p className="text-sm text-gray-800 mb-2">For the purposes of this Term & Conditions:</p>
                <ul className="list-disc list-inside space-y-2 text-sm text-gray-700">
                    <li><strong>Account:</strong> A unique account created for You...</li>
                    <li><strong>Affiliate:</strong> An entity that controls, is controlled by, or is under common control...</li>
                    <li><strong>Application:</strong> Refers to Urban Cab Partner, the software...</li>
                    <li><strong>Company:</strong> Refers to Urban Cab Partner.</li>
                    <li><strong>Country:</strong> Refers to Rajasthan, India.</li>
                    <li><strong>Device:</strong> Any device that can access the Service...</li>
                    <li><strong>Personal Data:</strong> Any information that relates to an identified or identifiable individual.</li>
                    <li><strong>Service:</strong> Refers to the Application.</li>
                    <li><strong>Service Provider:</strong> A natural or legal person who processes data...</li>
                    <li><strong>Usage Data:</strong> Data collected automatically...</li>
                    <li><strong>You:</strong> The individual accessing or using the Service...</li>
                </ul>

                <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Collecting and Using Your Personal Data</h3>
                <h4 className="text-lg font-semibold text-gray-800 mb-1">Types of Data Collected</h4>

                <h5 className="text-sm font-semibold text-gray-700 mt-4">Personal Data</h5>
                <p className="text-sm text-gray-800 mb-2">
                    While using Our Service, We may ask You to provide Us with certain personally identifiable information...
                </p>
                <ul className="list-disc list-inside space-y-2 text-sm text-gray-700">
                    <li>Email address</li>
                    <li>First name and last name</li>
                    <li>Phone number</li>
                    <li>Address, State, Province, ZIP/Postal code, City</li>
                    <li>Usage Data</li>
                </ul>

                <h5 className="text-sm font-semibold text-gray-700 mt-4">Usage Data</h5>
                <p className="text-sm text-gray-800 mb-4">
                    Usage Data is collected automatically when using the Service. It may include information such as Your Device's
                    IP address, browser type, version, and other diagnostic data...
                </p>

                <h4 className="text-lg font-semibold text-gray-800 mb-1">Information Collected while Using the Application</h4>
                <p className="text-sm text-gray-800 mb-4">
                    While using Our Application, in order to provide features of Our Application, We may collect, with Your prior
                    permission: Information regarding your location... You can enable or disable access to this information at any
                    time, through Your Device settings.
                </p>

                <h4 className="text-lg font-semibold text-gray-800 mb-1">Use of Your Personal Data</h4>
                <ul className="list-disc list-inside space-y-2 text-sm text-gray-700">
                    <li><strong>Service Provision and Maintenance:</strong> Helps us maintain and monitor the service.</li>
                    <li><strong>Account Management:</strong> Enable personalized features for registered users.</li>
                    <li><strong>Contract Fulfillment:</strong> Facilitate purchases, deliveries, etc.</li>
                    <li><strong>Communication:</strong> Provide updates and alerts.</li>
                    <li><strong>Marketing and Promotions:</strong> With consent, send new offers, etc.</li>
                    <li><strong>Request Management:</strong> Address inquiries and complaints.</li>
                </ul>

                <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-1">Sharing of Your Personal Data</h4>
                <ul className="list-disc list-inside space-y-2 text-sm text-gray-700">
                    <li><strong>Service Providers:</strong> Third-party vendors help analyze and monitor service.</li>
                    <li><strong>Business Transactions:</strong> Shared during company asset transitions.</li>
                    <li><strong>Affiliates:</strong> Under the same Term & Conditions.</li>
                    <li><strong>With Your Consent:</strong> Requires your approval for disclosure.</li>
                </ul>

                <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-1">Retention of Your Personal Data</h4>
                <ul className="list-disc list-inside space-y-2 text-sm text-gray-700">
                    <li><strong>Legal Obligations:</strong> Required for legal compliance and agreements.</li>
                    <li><strong>Usage Data:</strong> May be retained longer for analytics or service improvement.</li>
                </ul>

                <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-1">Transfer of Your Personal Data</h4>
                <p className="text-sm text-gray-800 mb-4">
                    Your data may be stored or transferred across various regions, subject to differing laws. We ensure protections are in place.
                </p>

                <h4 className="text-lg font-semibold text-gray-800 mb-1">Delete Your Personal Data</h4>
                <p className="text-sm text-gray-800 mb-2">
                    You have the right to request deletion of your personal data, with limitations where legal obligations exist.
                </p>

                <h4 className="text-lg font-semibold text-gray-800 mb-1">Disclosure of Your Personal Data</h4>
                <p className="text-sm text-gray-800 mb-2">Involves business transactions, legal requests, and other legal requirements.</p>

                <h4 className="text-lg font-semibold text-gray-800 mb-1">Security of Your Personal Data</h4>
                <p className="text-sm text-gray-800 mb-4">
                    While we strive to protect your data, no method of electronic storage or transmission is 100% secure.
                </p>

                <h4 className="text-lg font-semibold text-gray-800 mb-1">Children's Privacy</h4>
                <p className="text-sm text-gray-800 mb-4">
                    Our service does not address individuals under the age of 13. If discovered, we will take steps to delete their data.
                </p>

                <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Links to Other Websites</h3>
                <p className="text-sm text-gray-800 mb-4">
                    Our Service may contain links to third-party websites. We are not responsible for their content or privacy policies.
                </p>

                <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Changes to this Term & Conditions</h3>
                <p className="text-sm text-gray-800 mb-4">
                    We may update these terms periodically and notify users accordingly. You are encouraged to review this page regularly.
                </p>


                <h3 className="text-xl font-semibold mt-4">Contact Us</h3>
                <div>
                    <p className='text-[18px] font-medium text-gray-500 mb-2'>If you have any questions, contact us:</p>
                    <p className=''> <span className=" font-semibold">Legal Name :</span> DIVIRAJ TAXI AND RENTALS PRIVATE LIMITED</p>
        <p className=''> <span className=" font-semibold">Registered Business Address :</span> 675-B, S.NATHPURAM, KOTA, Kota, Rajasthan, 324010</p>
                    Email: <a href="mailto:urbancabpartner@gmail.com" className="text-blue-600 underline">urbancabpartner@gmail.com</a>
                    <br /> Phone: <a href="tel:+919783966966
 " className="text-blue-600 underline">9783966966
 </a>
                </div>
            </div>
        </div>
    );
};

export default TermConditions;
